import CustomTable from "../../CustomTable";
import { pdficon4, plusicon } from "../../imagepath";
import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  Select,
  DatePicker,
  Button,
  message,
  InputNumber,
  Form,
  Skeleton,
} from "antd";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { post } from "../../../services/base";
import { MedicInformationContext } from "../../../context/MedicInformationContextProvider";
import {procedenciasCode} from "../../../utils/enums/statusCodes";
import tipoPreguntasResultado from "../../../utils/enums/tipoPreguntasResultado";
import { getClinicResultsCode } from "../../../services/dim";

const { Option } = Select;
const ResultadosClinicos = () => {

  const [modalVisible, setModalVisible] = useState(false);
  const [codeResultadosClinicos, setCodeResultadosClinicos] = useState([]);
  const [selectedExamenType, setSelectedExamenType] = useState(null);

  const [seletedResultadoClinico, setSelectedResultadoClinico] = useState({
    key: null,
    value: null,
  });

  const [seletedResultadoClinicoType, setSelectedResultadoClinicoType] =
    useState({ key: null, value: null });

  const {
    resultadosClinicos,
    codeResultadosClinicosType,
    updateResultadosClinicos,
  } = useContext(MedicInformationContext);


  const [estado, setEstado] = useState(null);
  const gestor = localStorage.getItem("username");
  const [resultadosClinicosForm] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [loadingAdd, setLoadingAdd] = useState(false);
  var afiliado = extractPatientIdFromUrl();

  const [formData, setFormData] = useState({
    examen: "",
    fechaToma: null,
  });


  //handlers
  const handleClinicResultTypeChange = async (value, option) => {
    setSelectedResultadoClinicoType({ key: option.key, value: value });
    setSelectedResultadoClinico(null);

    const resultadosClinicosCode = await getClinicResultsCode(null, option.key);
    setCodeResultadosClinicos(resultadosClinicosCode);
  };

  const handleModalCancel = () => {
    resultadosClinicosForm.resetFields();
    setLoadingAdd(false);
    setModalVisible(false);
  };

  useEffect(() => {
    if (
      resultadosClinicos &&
      codeResultadosClinicosType 
    ) {
      if (
        (resultadosClinicos.length &&
          codeResultadosClinicosType.length) >= 0
      ) {
        setLoading(false);
      }
    }
  }, [
    resultadosClinicos,
    codeResultadosClinicosType
  ]);

  const handleAgregar = async () => {
    resultadosClinicosForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          return;
        } else {
          try {
            setLoadingAdd(true);
            const dataToSend = {
              afiliado: afiliado,
              descripcion: seletedResultadoClinico.key,
              estado: estado.toString(),
              gestor: gestor,
              fecha: formData.fechaToma,
            };

            var response = await post(
              "/DatosClinicos/resultados",
              JSON.stringify(dataToSend)
            );
            if (response.data)
             message.success("Resultado de examen creado exitosamente.");
            
            handleModalCancel();
            updateResultadosClinicos();
          } catch (error) {
            setLoadingAdd(false);
            console.error("Error agrgando resultado de examen:", error);
            message.error(
              "Error al agregar resultado de examen. Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleClinicResultChange = (value, option) => {
    setSelectedResultadoClinico({ key: option.key, value: value });
    setSelectedExamenType(option.tipo);
    switch (option.tipo) {
      case tipoPreguntasResultado.Booleano.value:
        setEstado(null);
        break;
      case tipoPreguntasResultado.Numerico.value:
        setEstado("");
        break;
      default:
        setEstado("");
        break;
    }
  };


  const resultadosClinicosType = codeResultadosClinicosType.map(
    (option, index) => (
      <Option key={option.value} value={option.label}>
        {option.label}
      </Option>
    )
  );
  
  const columns = [
    {
      title: "Tipo",
      dataIndex: "tipoResultadoClinico",
      key: "tipoResultadoClinico",
      sorter: (a, b) => a.tipoResultadoClinico.localeCompare(b.Tipo),
      searchable: true,
    },
    {
      title: "Examen o indicadores",
      dataIndex: "examen",
      key: "examen",
      sorter: (a, b) => a.examen.localeCompare(b.Examen),
      searchable: true,
    },
    {
      title: "Resultado",
      dataIndex: "estado",
      key: "estado",
      sorter: (a, b) => a.estado.localeCompare(b.Estado),
      searchable: true,
    },
    {
      title: "Actualizacion",
      dataIndex: "actualizacion",
      key: "actualizacion",
      sorter: (a, b) => a.actualizacion.localeCompare(b.Actualizacion),
      searchable: true,
    },
    {
      title: "Fecha de Toma",
      dataIndex: "fechaToma",
      key: "fechaToma",
      sorter: (a, b) => a.fechaToma.localeCompare(b.fechaToma),
      searchable: true,
    },
    {
      title: "Fecha de Actualizacion",
      dataIndex: "fechaActualizacion",
      key: "fechaActualizacion",
      sorter: (a, b) =>
        a.fechaActualizacion.localeCompare(b.fechaActualizacion),
      searchable: true,
    },
  ];

  const rowSelection = {
  };
  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Resultados de Exámenes</h4>{" "}
      </div>
      {loading ? (
        <div style={{ padding: "20px" }}>
          <Skeleton active />
        </div>
      ) : (
        <>
          {resultadosClinicos && (
            <CustomTable
              dataSource={resultadosClinicos}
              columns={columns}
              rowSelection={rowSelection}
              contexto={procedenciasCode.ResultadoClinico.value}
              updateDataSource={
                updateResultadosClinicos == undefined
                  ? {}
                  : updateResultadosClinicos
              }
            />
          )}
          {resultadosClinicos !== null && (
            <Button
              className="btn btn-primary add-pluss ms-2"
              onClick={() => setModalVisible(true)}
            >
              <img src={plusicon} alt="#" />
              Agregar
            </Button>
          )}
        </>
      )}
      <Modal
        title="Agregar Resultado de Examen"
        open={modalVisible}
        onCancel={handleModalCancel}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancelar
          </Button>,
          <Button key="save" type="primary" loading={loadingAdd} onClick={handleAgregar}>
            Guardar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
      >
        <div className="row">
          <div className="col-sm-12">
            <br></br>
            <Form form={resultadosClinicosForm}>
              <div className="row">
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms">
                    <label>
                      Tipo <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"tipo"}
                      rules={[{ required: true, message: "Es requerido" }]}
                    >
                      <Select
                        id="buscar-tipo"
                        style={{ width: "100%" }}
                        value={seletedResultadoClinicoType}
                        onChange={handleClinicResultTypeChange}
                        required
                      >
                        {resultadosClinicosType}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-8">
                    <div className="form-group local-forms">
                      <label>
                        Examen <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"examen"}
                        rules={[{ required: true, message: "Es requerido" }]}
                      >
                        <Select
                          id="buscar-resultado"
                          style={{ width: "100%" }}
                          value={seletedResultadoClinico}
                          onChange={handleClinicResultChange}
                          showSearch
                          required
                        >
                          {codeResultadosClinicos &&
                            codeResultadosClinicos.length > 0 &&
                            codeResultadosClinicos.map((examen) => (
                              <Option key={examen.value} value={examen.label} tipo={examen.tipo}>
                                {examen.label}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-4">
                    <div className="form-group local-forms">
                      <label htmlFor="resultado">Resultado</label>
                      {/* Lógica para mostrar un selector si el tipo es cierto */}
                      {selectedExamenType === tipoPreguntasResultado.Booleano.value && (
                        <Form.Item
                          name={"resultado"}
                          rules={[{ required: false, message: "Es requerido" }]}
                        >
                          <Select
                            style={{ width: "100%" }}
                            value={estado}
                            onChange={(value) => setEstado(value)}
                          >
                            <Option value="si">Sí</Option>
                            <Option value="no">No</Option>
                          </Select>
                        </Form.Item>
                      )}

                      {/* Lógica para mostrar un campo de texto si el tipo es distinto de cierto */}
                      {selectedExamenType == tipoPreguntasResultado.Numerico.value && (
                        <Form.Item
                          name={"estado"}
                          rules={[{ required: false, message: "Es requerido" }]}
                        >
                        <InputNumber
                          onChange={(value) => setEstado(value)}
                        />
                      </Form.Item>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms cal-icon">
                    <label>
                      Fecha de Toma<span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"fecha"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                    <DatePicker
                      placeholder=""
                      className="form-control datetimepicker"
                      onChange={(date) =>
                        setFormData({ ...formData, fechaToma: date })
                      }
                      suffixIcon={null}
                    />
                    </Form.Item>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ResultadosClinicos;
